import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Stack } from "@mui/material";
import { useGetServiceListMutation } from "config/api/waV1_user";
import { useGetFileMutation } from "config/api/waV1_file";
import ImageButton from "../ImageButton";
import { KEY_FORM_CS_COL_SH_HOLDING, KEY_FORM_CS_TITLE_1, KEY_FORM_CS_TITLE_2, KEY_FORM_EX_CP_TITLE_1, KEY_FORM_EX_CS_TITLE_1, KEY_FORM_TITLE_1, KEY_FORM_TITLE_2, KEY_FORM_TITLE_3, KEY_FORM_TITLE_4, KEY_FORM_TITLE_5, KEY_FORM_TITLE_6, KEY_FORM_VO_COL_BUS_REG_LICENSE, KEY_FORM_VO_COL_BUS_REG_LICENSE_NO, KEY_FORM_VO_COL_BUS_REG_LICENSE_YES, KEY_FORM_VO_COL_BUS_REG_NUM, KEY_FORM_VO_COL_IDENTITY, KEY_FORM_VO_COL_IDENTITY_COM, KEY_FORM_VO_COL_IDENTITY_IND, KEY_FORM_VO_COL_IDENTITY_ORG, KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS, KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY, KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN, KEY_FORM_VO_COL_MAIN_CONTACT_PHONE, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE, KEY_FORM_VO_COL_ORG_NUM, KEY_FORM_VO_COL_REG_CONNTRY, KEY_FORM_VO_COL_REG_DATE, KEY_FORM_VO_TITLE_1, KEY_FORM_VO_TITLE_2, KEY_FORM_VO_TITLE_3, KEY_FORM_VO_TITLE_4, KEY_LABEL_FORM_ADDRESS, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER, KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE, KEY_LABEL_FORM_BOARD_COM_REG_ADDR, KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM, KEY_LABEL_FORM_BOARD_COM_REG_C, KEY_LABEL_FORM_BOARD_COM_REG_NUM, KEY_LABEL_FORM_BOARD_HOLADING, KEY_LABEL_FORM_BOARD_INDENTITY, KEY_LABEL_FORM_BOARD_NO_AFTER, KEY_LABEL_FORM_BOARD_NO_BEFORE, KEY_LABEL_FORM_BOARD_NUM, KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER, KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE, KEY_LABEL_FORM_BOARD_SH_CN_NAME, KEY_LABEL_FORM_BOARD_SH_EMAIL, KEY_LABEL_FORM_BOARD_SH_EN_NAME, KEY_LABEL_FORM_BOARD_SH_IC_AFTER, KEY_LABEL_FORM_BOARD_SH_IC_BEFORE, KEY_LABEL_FORM_BOARD_SH_ID_AFTER, KEY_LABEL_FORM_BOARD_SH_ID_BEFORE, KEY_LABEL_FORM_BOARD_SH_PHONE, KEY_LABEL_FORM_BUS_NATURE, KEY_LABEL_FORM_BUS_REGION, KEY_LABEL_FORM_COM_ADDR, KEY_LABEL_FORM_COM_ADDR_REG, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES, KEY_LABEL_FORM_COM_CN_NAME, KEY_LABEL_FORM_COM_EN_NAME, KEY_LABEL_FORM_CONTACT_SLOT, KEY_LABEL_FORM_CONTACT_WAY, KEY_LABEL_FORM_EMAIL, KEY_LABEL_FORM_IS_NUM, KEY_LABEL_FORM_NAME, KEY_LABEL_FORM_PHONE, KEY_LABEL_FORM_PRESET_SHARES, KEY_LABEL_FORM_PRESET_SHARES_EN, KEY_LABEL_FORM_PRESET_SHARES_NO, KEY_LABEL_FORM_PRESET_SHARES_YES, KEY_LABEL_FORM_TITLE, KEY_LABEL_FORM_UPLOADED_FILE, KEY_LABEL_FORM_VAL, KEY_LABEL_FORM_VALUE_ADDED, KEY_LABEL_FORM_VAL_EN, KEY_LABEL_FORM_VAL_TOTAL, KEY_LABEL_FORM_VAL_TOTAL_EN, MODULE_PREVIEW_ROUTER_FORM } from "config/const/locale";
import { format } from "date-fns";
import { rmEl } from "utils/removeRepeatedEl";



function PreviewFormRouter_excs() {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const location = useLocation()

    const {
        name,
        title,
        identity,
        en_name,
        zh_name,
        address,
        page,
        company_name_en,
        company_name_zh,
        has_bus_reg_license,
        reg_date,
        bus_reg_num,
        reg_country,
        org_num,
        sMemberNum,
        shareholders,
        eService,
        source_of_fund,
        phone,
        email,
        contact_way,
        wechat_no,
        contact_timeslot,
        company_address,
        is_use_wa_addr,
        company_reg_address,
        is_std_share_value,
        no_shares_issued,
        shares_par_value,
        shares_total_value,
        business_nature,
        geo_location_bus_nature,
        files,
        user_id,
        service,
        c_title,
        c_en_name,
        c_zh_name,
        c_phone,
        c_email,
    } = location.state?.user_service

    const { items } = location.state
    const [serv, setServ] = React.useState([])
    const [filesData, setFilesData] = useState([])
    const [getSLFn] = useGetServiceListMutation()
    const [getFileFn] = useGetFileMutation()

    const steps = [
        t(KEY_FORM_TITLE_2),
        t(KEY_FORM_EX_CP_TITLE_1),
        t(KEY_FORM_EX_CS_TITLE_1),
    ];


    const handleGetFile = useCallback((paths) => {
        setFilesData([])

        paths?.map(i => {
            getFileFn(i?.file_path)
                .then(data => {
                    let label = i.file_path?.split('/')
                    setFilesData(p => [...p, { id: i.id, label: label[label.length - 1], type: i?.doc_type, data }])
                    // return data
                })
                .catch(reason => {
                    console.log('err', reason)
                })
                .finally(() => {
                    setFilesData(p => rmEl(p))
                })
        })

    }, [files])

    useEffect(() => {
        handleGetFile(files)
        getSLFn()
            .then(
                res => {
                    if (res.data?.data) {
                        setServ(res.data?.data?.services?.data)
                    }
                }
            )
    }, [])

    const memNoRenderer = () => shareholders?.map(
        (i, index) => {
            return (
                <Grid container key={index}>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{new Array(i?.type).map(i => i)}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i?.identity}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{i.en_name}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.zh_name}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_PHONE)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{i.tel}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.email}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{i.address}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_FORM_CS_COL_SH_HOLDING)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.shholding}</Typography></Grid>
                    <Grid item sm={12} xs={12} sx={{ borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}>&nbsp;</Typography></Grid>
                    {/* {
                        i.type == t(KEY_LABEL_FORM_BOARD_INDENTITY)
                            ? (
                                <>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_ADDR)} </Typography></Grid>
                                    <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.co_register_office_addr}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_NUM)} </Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{i.co_incorp_no}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM)} </Typography></Grid>
                                    <Grid item sm={3} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.business_registration}</Typography></Grid>
                                    <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{t(KEY_LABEL_FORM_BOARD_COM_REG_C)} </Typography></Grid>
                                    <Grid item sm={9} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{i.formation_country}</Typography></Grid>
                                </>
                            )
                            : (isEmpty(source_of_fund) && isEmpty(shareholders[0]?.source_of_fund))
                                ? false
                                : (
                                    <>
                                        <Grid item sm={3} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'>{isEmpty(source_of_fund) ? `${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE)}${index + 1}${t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER)}` : t(KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE)} </Typography></Grid>
                                        <Grid item sm={9} sx={{ borderTop: '1px solid black' }} ><Typography variant='p'>{isEmpty(source_of_fund) ? i.source_of_fund : source_of_fund}</Typography></Grid>
                                    </>
                                )
                    } */}
                </Grid>
            )
        }
    )

    const fileRederer = useCallback(() => (
        <Box sx={{ width: '80%', m: '0 auto', pt: 2, border: '1px solid black', fontSize: 16, lineHeight: 2 }}>
            <Typography variant='h4' > {t(KEY_LABEL_FORM_UPLOADED_FILE)}</Typography>

            <Box>
                <Stack display={'flex'} direction={'row'} gap={2} flexWrap={'wrap'}>
                    <Grid container spacing={2}>
                        {
                            filesData
                                .map(i => <Grid item sm={10} xs={10}><ImageButton key={i.id} data={i.data} label={i.label} type={i.type} /></Grid>)
                        }
                    </Grid>
                </Stack>
            </Box>
        </Box>
    ), [filesData])

    return (
        <>
            <Box sx={{ width: '80%', m: '0 auto', border: '1px solid black', fontSize: 16, lineHeight: 2 }}>
                <Grid container>
                    <Grid item sm={12} xs={12} sx={{}}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[0]}</Typography></Grid>
                    <Grid item sm={12} xs={12} sx={{ borderTop: '1px solid black' }}><Typography variant='p'>{serv.filter(i => i.id == service?.id)[0]?.locale_name}</Typography></Grid>

                    <Grid item sm={12} xs={12} sx={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}>&nbsp;</Typography></Grid>
                    <Grid item sm={12} xs={12} sx={{ borderBottom: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[1]}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </Typography></Grid>
                    <Grid item sm={10} xs={10} sx={{ borderBottom: '1px solid black' }}><Typography variant='p'> {c_title}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {c_en_name}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} </Typography></Grid>
                    <Grid item sm={4} xs={4} ><Typography variant='p'> {c_zh_name}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_PHONE)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'> {c_phone}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black', borderTop: '1px solid black' }}><Typography variant='p'> {t(KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderTop: '1px solid black' }}><Typography variant='p'> {c_email}</Typography></Grid>

                    <Grid item sm={12} xs={12} sx={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}>&nbsp;</Typography></Grid>
                    <Grid item sm={12} xs={12} sx={{ borderBottom: '1px solid black' }}><Typography variant='h5' sx={{ fontWeight: 700 }}> {steps[2]}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_EN_NAME)} </Typography></Grid>
                    <Grid item sm={4} xs={4} sx={{ borderRight: '1px solid black', }}><Typography variant='p'> {company_name_en}</Typography></Grid>
                    <Grid item sm={2} xs={2} sx={{ borderRight: '1px solid black' }}><Typography variant='p'> {t(KEY_LABEL_FORM_COM_CN_NAME)} </Typography></Grid>
                    <Grid item sm={4} xs={4} ><Typography variant='p'> {company_name_zh}</Typography></Grid>

                </Grid>
            </Box>

            {fileRederer()}
        </>
    );
}

export default React.memo(PreviewFormRouter_excs)